import React, { useEffect, useState } from "react";
import { Loader } from "./loader";
import api from "../../api";
import moment from "moment";
import "./AdminDashboard.css";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

export const DataInfo = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [genderPie, setGenderPie] = useState([]);

  const getUsers = async () => {
    try {
      setLoader(true);
      const response = await api.getDataInfo();
      setData(response);
      setLoader(false);

      // Generate chart data based on response
      if (response?.recentUser) {
        generateChartData(
          response.recentUser,
          response?.genderStats,
          response?.signupChart,
        );
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const generateChartData = (users, genderStats, signupChart) => {
    // Generate user growth data (last 7 days)

    // Generate random signup data for demo

    let male = 0,
      female = 0,
      other = 0;

    genderStats.forEach((g) => {
      if (g._id === "male") male = g.count;
      else if (g._id === "female") female = g.count;
      else other += g.count;
    });

    const totalGender = male + female + other || 1;

    const genderDistribution = {
      male: Math.round((male / totalGender) * 100),
      female: Math.round((female / totalGender) * 100),
      other: Math.round((other / totalGender) * 100),
      total: totalGender,
    };
    const genderPieData = [
      { name: "Male", value: genderDistribution.male },
      { name: "Female", value: genderDistribution.female },
      { name: "Other", value: genderDistribution.other },
    ];
    setGenderPie(genderPieData);

    setChartData({
      signupData: signupChart?.data,
      labels: signupChart?.labels,
      genderDistribution,
    });
  };

  useEffect(() => {
    getUsers();
  }, []);
  console.log(chartData);

  const getBarHeight = (value) => {
    const MAX_BAR_HEIGHT = 160;
    const maxValue = Math.max(...chartData.signupData, 1);
    return `${(value / maxValue) * MAX_BAR_HEIGHT}px` || 0;
  };

  const formatNumberUnit = (value) => {
    if (!value && value !== 0) return "0";

    const absValue = Math.abs(value);

    if (absValue >= 1e9) {
      return (value / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
    }
    if (absValue >= 1e6) {
      return (value / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (absValue >= 1e3) {
      return (value / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
    }
    return value.toString();
  };

  return (
    <>
      <div className="container-fluid payHistoryPage admin-dashboard">
        {/* Analytics Cards Row */}
        <div className="row analytics-row">
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="Total Users"
            amount={data?.userCount}
            colorClass="analytics-primary"
          />
          {/* <AnalyticsBox
            icon={<i className="fa-solid fa-wallet"></i>}
            title="Total Wallets"
            amount={data?.walletCount}
            colorClass="analytics-success"
          /> */}
          {/* <AnalyticsBox
            icon={<i className="fa-solid fa-paste"></i>}
            title="Total Posts"
            amount={data?.PostCount}
            colorClass="analytics-info"
          /> */}
          {/* <AnalyticsBox
            icon={<i className="fa-solid fa-money-bill-transfer"></i>}
            title="Active Subscriptions"
            amount={data?.PaidUsers}
            colorClass="analytics-warning"
            // trend={data?.PaidUsers > 0 ? "+12" : null}
          /> */}
          <AnalyticsBox
            icon={<i className="fa-solid fa-ban"></i>}
            title="Expired Subscriptions"
            amount={data?.expiredUsers}
            colorClass="analytics-danger"
          />
        </div>

        {/* Quick Stats Row */}
        {/* <div className="row quick-stats-row">
          <div className="col-md-3 col-sm-6">
            <div className="stats-card">
              <div className="stats-icon">
                <i className="fas fa-user-plus"></i>
              </div>
              <div className="stats-content">
                <div className="stats-value">24</div>
                <div className="stats-label">New Users (7d)</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="stats-card">
              <div className="stats-icon stats-icon-success">
                <i className="fas fa-check-circle"></i>
              </div>
              <div className="stats-content">
                <div className="stats-value">78%</div>
                <div className="stats-label">Verification Rate</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="stats-card">
              <div className="stats-icon stats-icon-warning">
                <i className="fas fa-clock"></i>
              </div>
              <div className="stats-content">
                <div className="stats-value">42</div>
                <div className="stats-label">Active Today</div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="stats-card">
              <div className="stats-icon stats-icon-info">
                <i className="fas fa-coins"></i>
              </div>
              <div className="stats-content">
                <div className="stats-value">$245.50</div>
                <div className="stats-label">Avg. Wallet</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Charts Row */}
        <div className="row charts-row">
          <div className="col-xl-8 col-lg-7">
            <div className="card chart-card">
              <div className="card-header chart-card-header">
                <h6 className="chart-title">User Signups (Last 7 Days)</h6>
                <div className="chart-period">
                  <span className="active">7D</span>
                  {/* <span>1M</span>
                  <span>1Y</span> */}
                </div>
              </div>
              <div className="card-body chart-card-body">
                {chartData ? (
                  <div className="bar-chart">
                    {chartData.signupData.map((value, index) => (
                      <div key={index} className="bar-chart-item">
                        <div className="bar-chart-label">
                          {chartData.labels[index]}
                        </div>
                        <div className="bar-chart-bar-container">
                          <div
                            className="bar-chart-bar"
                            style={{ height: getBarHeight(value) }}
                            title={`${value} users`}
                          >
                            <span className="bar-value">{value}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="chart-placeholder">
                    <i className="fas fa-chart-bar chart-icon"></i>
                    <p>Loading chart data...</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Gender Distribution */}
          <div className="col-xl-4 col-lg-5">
            <div className="card chart-card">
              <div className="card-header chart-card-header">
                <h6 className="chart-title">Gender Distribution</h6>
              </div>
              <div className="card-body chart-card-body">
                <div className="gender-chart-container">
                  <div className="gender-legend">
                    <div className="legend-item">
                      <div className="legend-color legend-male"></div>
                      <span className="legend-text">
                        Male: {chartData?.genderDistribution?.male || 0}%
                      </span>
                    </div>
                    <div className="legend-item">
                      <div className="legend-color legend-female"></div>
                      <span className="legend-text">
                        Female: {chartData?.genderDistribution?.female || 0}%
                      </span>
                    </div>
                    <div className="legend-item">
                      <div className="legend-color legend-other"></div>
                      <span className="legend-text">
                        Other: {chartData?.genderDistribution?.other || 0}%
                      </span>
                    </div>
                  </div>
                  <div className="pie-chart">
                    {/* <div className="pie-chart-circle">
                      <div
                        className="pie-chart-slice male"
                        style={{
                          "--percentage": `${
                            chartData?.genderDistribution?.male || 0
                          }%`,
                        }}
                      ></div>
                      <div
                        className="pie-chart-slice female"
                        style={{
                          "--percentage": `${
                            chartData?.genderDistribution?.female || 0
                          }%`,
                        }}
                      ></div>
                      <div
                        className="pie-chart-slice other"
                        style={{
                          "--percentage": `${
                            chartData?.genderDistribution?.other || 0
                          }%`,
                        }}
                      ></div>
                    </div> */}
                    <PieGenderChart genderPieData={genderPie} />
                    <div className="pie-chart-center">
                      <div className="total-users">
                        {formatNumberUnit(
                          chartData?.genderDistribution?.total,
                        ) || 0}
                      </div>
                      <div className="total-label">Total</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Users Table - KEEPING ORIGINAL STRUCTURE */}
        <div className="row table-section">
          <div className="col">
            <div className="section-header">
              <h3 className="section-title">Recent Users</h3>
              {/* <div className="table-actions">
                <button className="btn-action">
                  <i className="fas fa-download"></i> Export
                </button>
                <button className="btn-action">
                  <i className="fas fa-filter"></i> Filter
                </button>
                <button className="btn-action">
                  <i className="fas fa-sync-alt"></i> Refresh
                </button>
              </div> */}
            </div>
            <Table data={data?.recentUser ? data?.recentUser : []} />
          </div>
        </div>
      </div>
      {loader && <Loader />}
    </>
  );
};

function AnalyticsBox(props) {
  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div
        className={`card analytics-card h-100 py-2 ${props.colorClass || ""}`}
      >
        <div className="card-body">
          <div className="analytics-card-content">
            <div className="analytics-icon">{props.icon}</div>
            <div className="analytics-text">
              <div className="analytics-title">{props.title}</div>
              <div className="analytics-amount">{props.amount || 0}</div>
              {props.trend && (
                <div
                  className={`analytics-trend ${
                    props.trend > 0 ? "trend-up" : "trend-down"
                  }`}
                >
                  <i
                    className={`fas fa-arrow-${
                      props.trend > 0 ? "up" : "down"
                    }`}
                  ></i>
                  {props.trend}%
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Table = ({ data }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    // Filter data based on search and status
    const filtered = data.filter((item) => {
      // Search filter
      const matchesSearch =
        searchTerm === "" ||
        item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.phone?.toLowerCase().includes(searchTerm.toLowerCase());

      // Status filter (verified/unverified)
      const matchesStatus =
        statusFilter === "all" ||
        (statusFilter === "verified" && item?.emailVerified) ||
        (statusFilter === "unverified" && !item?.emailVerified);

      return matchesSearch && matchesStatus;
    });

    setFilteredData(filtered);
  }, [data, searchTerm, statusFilter]);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      {/* Search and Filter Bar - Add above the table */}
      <div className="row search-filter-section mb-4">
        <div className="col-md-8">
          <div className="search-box-wrapper">
            <i className="fas fa-search search-box-icon"></i>
            <input
              type="text"
              className="search-box-input"
              placeholder="Search users by name, email, or phone..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="filter-actions">
            <select
              className="filter-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All Users</option>
              <option value="verified">Verified Only</option>
              <option value="unverified">Unverified Only</option>
            </select>
          </div>
        </div>
      </div>

      <div className="card table-card sortby-box br-10 mt-3">
        <div className="card-header br-10 bg-white p-0 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table modern-table">
              <thead>
                <tr>
                  <th scope="col" className="table-header">
                    Joined At
                  </th>
                  <th scope="col" className="table-header">
                    Name
                  </th>
                  <th scope="col" className="table-header">
                    Email
                  </th>
                  <th scope="col" className="table-header">
                    Phone
                  </th>
                  <th scope="col" className="table-header">
                    Wallet
                  </th>
                  <th scope="col" className="table-header">
                    Country
                  </th>
                  <th scope="col" className="table-header">
                    DOB
                  </th>
                  <th scope="col" className="table-header">
                    Gender
                  </th>
                  <th scope="col" className="table-header">
                    <div className="w-max-c">Email verified</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, key) => (
                  <tr key={key} className="table-row">
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                    <td scope="row" className="d-flex">
                      <div className="table-text-dark w-max-c db user-with-avatar">
                        <span className="user-avatar-small">
                          {item?.name?.charAt(0) || "U"}
                        </span>
                        {item?.name}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.phone ? item?.phone : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.wallet
                          ? `$${parseFloat(item.wallet).toFixed(2)}`
                          : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.country ? (
                          <span className="country-flag">
                            <i className="fas fa-globe-americas"></i>{" "}
                            {item.country}
                          </span>
                        ) : (
                          "-"
                        )}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.dob || "-"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`table-text-dark w-max-c db gender-badge gender-${
                          item?.gender?.toLowerCase() || "unknown"
                        }`}
                      >
                        {item?.gender || "-"}
                      </span>
                    </td>
                    <td>
                      {item?.emailVerified ? (
                        <span className="badge badge-success w-max-c db">
                          <i className="fas fa-check-circle"></i> verified
                        </span>
                      ) : (
                        <span className="badge badge-danger w-max-c db">
                          <i className="fas fa-times-circle"></i> not verified
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Empty State */}
        {filteredData.length === 0 && (
          <div className="empty-table-state">
            <div className="empty-state-content">
              {data.length === 0 ? (
                <>
                  <i className="fas fa-users empty-state-icon"></i>
                  <h4 className="empty-state-title">No users found</h4>
                  <p className="empty-state-description">
                    There are no users in the system yet.
                  </p>
                </>
              ) : (
                <>
                  <i className="fas fa-search empty-state-icon"></i>
                  <h4 className="empty-state-title">No matching users</h4>
                  <p className="empty-state-description">
                    No users match your search criteria. Try a different search
                    term.
                  </p>
                  <button
                    className="btn-clear-filters"
                    onClick={() => {
                      setSearchTerm("");
                      setStatusFilter("all");
                    }}
                  >
                    Clear Filters
                  </button>
                </>
              )}
            </div>
          </div>
        )}

        {/* Table Footer */}
        {/* {filteredData.length > 0 && (
          <div className="card-footer table-footer">
            <div className="table-summary">
              Showing {filteredData.length} of {data.length} users
            </div>
            <div className="table-pagination">
              <button className="page-btn disabled">← Previous</button>
              <button className="page-btn active">1</button>
              <button className="page-btn">2</button>
              <button className="page-btn">Next →</button>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

const PieGenderChart = ({ genderPieData }) => {
  const COLORS = ["#3B82F6", "#764ba2", "#11998e"]; // male, female, other
  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={genderPieData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={30}
          outerRadius={90}
          paddingAngle={3}
        >
          {genderPieData.map((_, index) => (
            <Cell key={index} fill={COLORS[index]} />
          ))}
        </Pie>

        <Tooltip formatter={(value) => `${value}%`} />
      </PieChart>
    </ResponsiveContainer>
  );
};
